import { lazy, Suspense } from "react";
import { SuspenseLoader } from "../../../assets/loaders";

const LazyComponent = lazy(() => import("./Profile"));

const index = () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <LazyComponent />
    </Suspense>
  );
};

export default index;
